import { useEffect, type ReactNode } from "react";
import {
  ADMIN_APP_URL,
  usePlatformCutoverFlag,
} from "@/hooks/usePlatformCutoverFlag";

/**
 * Wrapper que redireciona `/admin/*` para o novo admin dedicado em
 * `admin.playprosport.com.br` quando a flag remota `admin_cutover_enabled`
 * estiver ligada. Enquanto carrega a flag, segue mostrando o conteúdo
 * original — evita flash de redirect desnecessário.
 *
 * O redirect usa `window.location.replace` para o admin dedicado. O
 * caminho atual (ex: /admin/platform-fees) é preservado no destino.
 */
export function AdminCutoverGate({ children }: { children: ReactNode }) {
  const { data: enabled } = usePlatformCutoverFlag();

  useEffect(() => {
    if (!enabled) return;
    // Remove o prefixo /admin e preserva subpath: /admin/platform-fees → /platform-fees.
    // Usa boundary (?=\/|$) pra não casar /administracao, /admins etc.
    const path = window.location.pathname.replace(/^\/admin(?=\/|$)/, "") || "/";
    const target = `${ADMIN_APP_URL}${path}${window.location.search}`;
    window.location.replace(target);
  }, [enabled]);

  return <>{children}</>;
}
